module.exports = "/packs/media/images/SaveForGoal-d660c89d40cbc8cd5b75af101132805a.png";